import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CardContent } from '@mui/material';
import { useGetQuestionsQuery } from '../features/api/rest/apiQuestionsSlice';
import QuestionCard from './QuestionCard';
import Spinner from './Spinner';
import Error from './Error';

function QuestionsResults() {
  const { ean } = useParams();
  const [sorted, setSorted] = useState(false);
  const [sortedQuestions, setSortedQuestions] = useState([]);

  const { questions, isLoading, isFetching, isError } = useGetQuestionsQuery(
    { ean, mine: false },
    {
      selectFromResult: ({ data }) => ({
        questions: data?.results,
      }),
    }
  );

  const sortQuestions = () => {
    const sortingQuestions = questions.slice().sort((a, b) => new Date(b.created) - new Date(a.created));
    setSortedQuestions(sortingQuestions);
    setSorted(true);
  };

  if (isLoading || isFetching) return <Spinner />;
  if (isError) return <Error />;

  return (
    <Box>
      <CardContent sx={{ '&:last-child': { pb: 0 } }}>
        {!sorted && questions && sortQuestions()}
        {sortedQuestions.map((question) => (
          <QuestionCard key={question.id} id={question.id} owner={question.owner} question={question.body} totScore={question.tot_score} />
        ))}
      </CardContent>
    </Box>
  );
}

export default QuestionsResults;
